module.exports = __webpack_public_path__ + "img/Farm.10dfd516.jpg";